<template>
  <div>
    <div class="steps-header t-mb-lg">
      <div v-for="(step, index) in steps" :key="index" class="step-container">
        <div class="step-header" :class="{ selected: selectedIndex === index }">
          {{ index + 1 }}
        </div>
        <div class="divider" v-if="index < steps.length - 1"></div>
      </div>
    </div>
    <slot></slot>
    <div class="step-buttons t-mt-md">
      <Button
        class="t-ml-md"
        :label="buttonBackLabel"
        :handleClick="goBack"
        type="tertiary"
        v-if="selectedIndex > 0"
      />
      <Button
        class="t-ml-md"
        :label="buttonNextLabel"
        :handleClick="goNext"
        v-if="selectedIndex < steps.length - 1"
      />
      <Button
        class="t-ml-md"
        :handleClick="beforeSumit"
        :label="buttonSubmitLabel"
        v-if="selectedIndex === steps.length - 1"
      />
    </div>
  </div>
</template>
<script>
import Button from '../Button/Button.vue';

export default {
  name: 'Stepper',
  components: { Button },
  props: {
    handleSubmit: {
      type: Function,
      required: true,
    },
    buttonBackLabel: {
      type: String,
      default: 'Back',
    },
    buttonNextLabel: {
      type: String,
      default: 'Next',
    },
    buttonSubmitLabel: {
      type: String,
      default: 'Finalize',
    },
  },
  data() {
    return {
      selectedIndex: 0,
      steps: [],
    };
  },
  methods: {
    async goNext() {
      const stepValid = await this.validateStep(this.selectedIndex);
      if (stepValid) {
        this.selectStep(this.selectedIndex + 1);
      }
    },
    goBack() {
      this.selectStep(this.selectedIndex - 1);
    },
    async beforeSumit() {
      const stepValid = await this.validateStep(this.selectedIndex);
      if (stepValid) {
        this.handleSubmit();
      }
    },
    selectStep(i) {
      this.selectedIndex = i;
      this.steps.forEach((step, index) => {
        step.isSelected = index === i;
      });
    },
    async validateStep(index) {
      const step = this.steps[index];
      if (step.handleValidation) {
        const valid = await step.handleValidation();
        if (!valid) {
          return false;
        }
      }
      return true;
    },
    initSteps() {
      this.steps = this.$children;
      this.steps = this.steps.filter(
        (child) => child.$options._componentTag === 'Step',
      );
    },
  },
  mounted() {
    this.initSteps();
    this.selectStep(0);
  },
};
</script>
<style scoped lang="scss">
.step-buttons {
  display: flex;
  justify-content: flex-end;
}
.steps-header {
  display: flex;

  .step-container {
    display: flex;
    align-items: center;
  }

  .step-header {
    color: var(--track-color-bluegray-60);
    background: var(--track-color-bluegray-20);
    border-radius: 100%;
    width: 25px;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;

    &.selected {
      background: var(--track-color-brand-primary-lightest);
      color: var(--track-color-brand-primary);
    }
  }
  .divider {
    width: 50px;
    height: 2px;
    background: var(--track-color-bluegray-20);
  }
}
</style>
